<template>
    <div class="page">
        <div class="page-content">
            <div class="bk-page">
                <ul class="remen-card">
                    <li class="flex item b-line" v-for="item in cardList" @click="$router.push('/card/detail')">
                        <div class="l-bbb"><img src="../assets/images/cd-card.png"/></div>
                        <div>
                            <h4>{{item.name}}</h4>
                            <p class="p1">{{item.desc}}</p>
                            <p class="tags">
                                <a v-for="tag in item.tags">{{tag}}</a>
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            cardList: [{
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }]
        }
    }
}
</script>
